import React, { forwardRef } from "react";
import { styled, SxProps, Typography, TypographyProps } from "@mui/material";

export interface MxIconsProps {
  children?: React.ReactNode;
  color?: TypographyProps["color"];
  size?: 12 | 14 | 16 | 20 | 22 | 24 | 28 | 32 | 36 | 40 | 48 | 56 | 64;
  sx?: SxProps<any>;
  onClick?: (e: any) => void;
  className?: string;
}

const MxIcons = forwardRef<HTMLDivElement, MxIconsProps>((props, ref) => {
  const { ...rest } = props;
  return <CustomStyles ref={ref} {...rest} component="span" />;
});

export default MxIcons;

const CustomStyles = styled(Typography)<MxIconsProps>(({ theme, size = 16 }) => ({
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  "& svg": {
    height: size,
    width: size,
    "&.tabler-icon": {}
  }
}));
